export default [
    {
        path: '/admin/news-categories',
        name: 'news-category',
        meta: { requiresAuth: true },
        component: () => import('@/pages/website/news-category/index.vue')
    }
]
